var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',[_c('col2',[_c('v-icon',[_vm._v("fas fa-plug")])],1),_c('col5',[_vm._v(" "+_vm._s(_vm.worker.name)+" ")]),_c('col5',[_vm._v(" Last seen on: "+_vm._s(_vm.worker.last_seen_on)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }